/**
 * @owner @Appboy/core-objects
 */

import { z } from "zod";
import { stepGetBaseSchema } from "./stepGetBaseSchema";

export const userUpdateStepAttributeGetBaseSchema = z.object({
  type: z.string(),
  action: z.string(),
  name: z.string(),
  path: z.string(),
  personalize: z.boolean(),
});

export const userUpdateStepAttributeGetSchema = z.discriminatedUnion("type", [
  z.object({
    ...userUpdateStepAttributeGetBaseSchema.shape,
    type: z.literal("array"),
    action: z.enum(["add_item", "remove_item", "update", "remove"]),
    value: z.string().nullable(),
  }),
  z.object({
    ...userUpdateStepAttributeGetBaseSchema.shape,
    type: z.literal("boolean"),
    action: z.enum(["update", "remove", "increment"]),
    value: z.union([z.null(), z.boolean(), z.string()]),
  }),
  z.object({
    ...userUpdateStepAttributeGetBaseSchema.shape,
    type: z.literal("hash"),
    action: z.enum(["update", "remove"]),
    value: z.string().nullable(),
  }),
  z.object({
    ...userUpdateStepAttributeGetBaseSchema.shape,
    type: z.literal("number"),
    action: z.enum(["update", "remove", "increment", "decrement"]),
    value: z.union([z.null(), z.boolean(), z.number(), z.string()]),
  }),
  z.object({
    ...userUpdateStepAttributeGetBaseSchema.shape,
    type: z.literal("objectarray"),
    action: z.enum(["update", "remove"]),
    value: z.string().nullable(),
  }),
  z.object({
    ...userUpdateStepAttributeGetBaseSchema.shape,
    type: z.literal("string"),
    action: z.enum(["update", "remove", "increment"]),
    value: z.union([z.null(), z.boolean(), z.number(), z.string()]),
  }),
  z.object({
    ...userUpdateStepAttributeGetBaseSchema.shape,
    type: z.literal("time"),
    action: z.enum(["update", "remove"]),
    value: z.string().nullable(),
  }),
]);

export const userUpdateStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("USER_UPDATE"),
  step_data: z.object({
    rate_limit: z.int().nonnegative(),
    update_body: z.string().nullable(), // null: 34 (0.07%)
    update_body_metadata: z
      .object({
        attributes: z.array(userUpdateStepAttributeGetSchema).optional(),
      })
      .nullable(), // null: 420 (0.87%)
  }),
});
